(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-material3-material3.js', './androidx-window-window-core.js', './compose-multiplatform-core-compose-material3-adaptive-adaptive.js', './compose-multiplatform-core-compose-foundation-foundation-layout.js', './androidx-compose-runtime-runtime-saveable.js', './compose-multiplatform-core-compose-animation-animation-core.js', './compose-multiplatform-core-compose-ui-ui-text.js', './compose-multiplatform-core-compose-ui-ui-util.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-material3-material3.js'), require('./androidx-window-window-core.js'), require('./compose-multiplatform-core-compose-material3-adaptive-adaptive.js'), require('./compose-multiplatform-core-compose-foundation-foundation-layout.js'), require('./androidx-compose-runtime-runtime-saveable.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./compose-multiplatform-core-compose-ui-ui-text.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material3-material3'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-material3-material3' was not found. Please, check whether 'compose-multiplatform-core-compose-material3-material3' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['androidx-window-window-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'androidx-window-window-core' was not found. Please, check whether 'androidx-window-window-core' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-material3-adaptive-adaptive' was not found. Please, check whether 'compose-multiplatform-core-compose-material3-adaptive-adaptive' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation-layout' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation-layout' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-ui-ui-text' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-text' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'.");
    }
    globalThis['compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'] = factory(typeof globalThis['compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-material3-material3'], globalThis['androidx-window-window-core'], globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'], globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'], globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['compose-multiplatform-core-compose-ui-ui-util']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_material3_material3, kotlin_androidx_window_window_core, kotlin_org_jetbrains_compose_material3_adaptive_adaptive, kotlin_org_jetbrains_compose_foundation_foundation_layout, kotlin_androidx_compose_runtime_runtime_saveable, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_org_jetbrains_compose_ui_ui_text, kotlin_org_jetbrains_compose_ui_ui_util) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var _Color___get_value__impl__1pls5m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var Long = kotlin_kotlin.$_$.kn;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var _Color___init__impl__r6cqi2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.u2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var Surface = kotlin_org_jetbrains_compose_material3_material3.$_$.n1;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var Companion_getInstance_1 = kotlin_androidx_window_window_core.$_$.a;
  var equals = kotlin_kotlin.$_$.sf;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var MaterialTheme_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.z2;
  var androidx_compose_material3_MaterialTheme$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.b2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var currentWindowAdaptiveInfo = kotlin_org_jetbrains_compose_material3_adaptive_adaptive.$_$.b;
  var Arrangement_getInstance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.a2;
  var ShortNavigationBarDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.i3;
  var androidx_compose_material3_ShortNavigationBarDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.h2;
  var WideNavigationRailDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.n3;
  var androidx_compose_material3_WideNavigationRailDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.j2;
  var NavigationBarDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.a3;
  var androidx_compose_material3_NavigationBarDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.c2;
  var contentColorFor = kotlin_org_jetbrains_compose_material3_material3.$_$.l2;
  var NavigationRailDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.e3;
  var androidx_compose_material3_NavigationRailDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.f2;
  var DrawerDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.w2;
  var androidx_compose_material3_DrawerDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.z1;
  var NavigationBarItemDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.b3;
  var androidx_compose_material3_NavigationBarItemDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.d2;
  var NavigationRailItemDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.f3;
  var androidx_compose_material3_NavigationRailItemDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.g2;
  var NavigationDrawerItemDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.c3;
  var androidx_compose_material3_NavigationDrawerItemDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.e2;
  var rememberSaveable = kotlin_androidx_compose_runtime_runtime_saveable.$_$.j;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var PermanentDrawerSheet = kotlin_org_jetbrains_compose_material3_material3.$_$.c1;
  var NavigationRail = kotlin_org_jetbrains_compose_material3_material3.$_$.z;
  var NavigationBar = kotlin_org_jetbrains_compose_material3_material3.$_$.w;
  var Enum = kotlin_kotlin.$_$.en;
  var Saver = kotlin_androidx_compose_runtime_runtime_saveable.$_$.d;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var get_VectorConverter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y;
  var Animatable = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b;
  var derivedStateOf = kotlin_androidx_compose_runtime_runtime.$_$.p1;
  var animateFloatAsState = kotlin_org_jetbrains_compose_animation_animation_core.$_$.j1;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var isInterface = kotlin_kotlin.$_$.rg;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var layoutId = kotlin_org_jetbrains_compose_ui_ui.$_$.o4;
  var maybeCachedBoxMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.v;
  var BoxScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b2;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var BadgedBox = kotlin_org_jetbrains_compose_material3_material3.$_$.b;
  var movableContentOf = kotlin_androidx_compose_runtime_runtime.$_$.t1;
  var heightIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.s;
  var ShortNavigationBar = kotlin_org_jetbrains_compose_material3_material3.$_$.i1;
  var WideNavigationRailValue_Expanded_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.q3;
  var rememberWideNavigationRailState = kotlin_org_jetbrains_compose_material3_material3.$_$.r2;
  var WideNavigationRail = kotlin_org_jetbrains_compose_material3_material3.$_$.y1;
  var NavigationDrawerItem = kotlin_org_jetbrains_compose_material3_material3.$_$.x;
  var NavigationRailItem = kotlin_org_jetbrains_compose_material3_material3.$_$.y;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var ShortNavigationBarItemDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.j3;
  var androidx_compose_material3_ShortNavigationBarItemDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.i2;
  var padding = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c1;
  var ShortNavigationBarItem = kotlin_org_jetbrains_compose_material3_material3.$_$.h1;
  var WideNavigationRailItemDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.o3;
  var androidx_compose_material3_WideNavigationRailItemDefaults$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.k2;
  var WideNavigationRailItem = kotlin_org_jetbrains_compose_material3_material3.$_$.x1;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_material3_material3.$_$.d3;
  var MutableVector = kotlin_androidx_compose_runtime_runtime.$_$.a;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var MeasurePolicy = kotlin_org_jetbrains_compose_ui_ui.$_$.r3;
  var hashCode = kotlin_kotlin.$_$.bg;
  var minIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.q3;
  var minIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.p3;
  var maxIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.o3;
  var maxIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.n3;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.f2;
  var only = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.y;
  var consumeWindowInsets = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.m;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var isArray = kotlin_kotlin.$_$.jg;
  var NavigationBarItem = kotlin_org_jetbrains_compose_material3_material3.$_$.v;
  var _TextUnit___init__impl__r5fj1s = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h3;
  var _TextOverflow___init__impl__obguoe = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n2;
  var Text = kotlin_org_jetbrains_compose_material3_material3.$_$.t1;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var Constraints__copy$default_impl_f452rp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w3;
  var get_layoutId = kotlin_org_jetbrains_compose_ui_ui.$_$.n4;
  var throwNoSuchElementException = kotlin_org_jetbrains_compose_ui_ui_util.$_$.f;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var Spacer = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.f;
  var WindowInsets = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.g;
  var spring = kotlin_org_jetbrains_compose_animation_animation_core.$_$.y1;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(NavigationSuiteType, 'NavigationSuiteType');
  function item$default(selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource, $super) {
    modifier = modifier === VOID ? Companion_instance : modifier;
    enabled = enabled === VOID ? true : enabled;
    label = label === VOID ? null : label;
    alwaysShowLabel = alwaysShowLabel === VOID ? true : alwaysShowLabel;
    badge = badge === VOID ? null : badge;
    colors = colors === VOID ? null : colors;
    interactionSource = interactionSource === VOID ? null : interactionSource;
    var tmp;
    if ($super === VOID) {
      this.ixn(selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource);
      tmp = Unit_instance;
    } else {
      tmp = $super.ixn.call(this, selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource);
    }
    return tmp;
  }
  initMetadataForInterface(NavigationSuiteScope, 'NavigationSuiteScope');
  initMetadataForClass(NavigationSuiteColors, 'NavigationSuiteColors');
  initMetadataForObject(NavigationSuiteScaffoldDefaults, 'NavigationSuiteScaffoldDefaults');
  initMetadataForObject(NavigationSuiteDefaults, 'NavigationSuiteDefaults');
  initMetadataForObject(ComposableSingletons$NavigationSuiteScaffoldKt, 'ComposableSingletons$NavigationSuiteScaffoldKt');
  initMetadataForClass(NavigationSuiteScaffoldValue, 'NavigationSuiteScaffoldValue', VOID, Enum);
  initMetadataForClass(NavigationSuiteItemColors, 'NavigationSuiteItemColors');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(NavigationSuiteScaffoldStateImpl, 'NavigationSuiteScaffoldStateImpl', VOID, VOID, VOID, [0, 1]);
  initMetadataForClass(NavigationSuiteItem, 'NavigationSuiteItem');
  initMetadataForClass(NavigationSuiteScopeImpl, 'NavigationSuiteScopeImpl', NavigationSuiteScopeImpl, VOID, [NavigationSuiteScope]);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForObject(DpWidthSizeClasses, 'DpWidthSizeClasses');
  initMetadataForObject(DpHeightSizeClasses, 'DpHeightSizeClasses');
  //endregion
  function get_TallNavigationBarHeight() {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return TallNavigationBarHeight;
  }
  var TallNavigationBarHeight;
  function get_PrimaryActionContentPadding() {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return PrimaryActionContentPadding;
  }
  var PrimaryActionContentPadding;
  function get_NoWindowInsets() {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return NoWindowInsets;
  }
  var NoWindowInsets;
  function get_AnimationSpec() {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return AnimationSpec;
  }
  var AnimationSpec;
  var androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteScaffoldDefaults$stable;
  var androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteDefaults$stable;
  var androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteColors$stable;
  var androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteItemColors$stable;
  var androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteScaffoldStateImpl$stable;
  function _NavigationSuiteType___init__impl__9phgrp(description) {
    return description;
  }
  function _get_description__4f1tkb($this) {
    return $this;
  }
  function NavigationSuiteType__toString_impl_1t3131($this) {
    return _get_description__4f1tkb($this);
  }
  function Companion() {
    Companion_instance_0 = this;
    this.oxm_1 = _NavigationSuiteType___init__impl__9phgrp('ShortNavigationBarCompact');
    this.pxm_1 = _NavigationSuiteType___init__impl__9phgrp('ShortNavigationBarMedium');
    this.qxm_1 = _NavigationSuiteType___init__impl__9phgrp('WideNavigationRailCollapsed');
    this.rxm_1 = _NavigationSuiteType___init__impl__9phgrp('WideNavigationRailExpanded');
    this.sxm_1 = _NavigationSuiteType___init__impl__9phgrp('NavigationBar');
    this.txm_1 = _NavigationSuiteType___init__impl__9phgrp('NavigationRail');
    this.uxm_1 = _NavigationSuiteType___init__impl__9phgrp('NavigationDrawer');
    this.vxm_1 = _NavigationSuiteType___init__impl__9phgrp('None');
  }
  var Companion_instance_0;
  function Companion_getInstance_5() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function NavigationSuiteType__hashCode_impl_nk8xvw($this) {
    return getStringHashCode($this);
  }
  function NavigationSuiteType__equals_impl_jcu6s0($this, other) {
    if (!(other instanceof NavigationSuiteType))
      return false;
    if (!($this === (other instanceof NavigationSuiteType ? other.wxm_1 : THROW_CCE())))
      return false;
    return true;
  }
  function NavigationSuiteType(description) {
    Companion_getInstance_5();
    this.wxm_1 = description;
  }
  protoOf(NavigationSuiteType).toString = function () {
    return NavigationSuiteType__toString_impl_1t3131(this.wxm_1);
  };
  protoOf(NavigationSuiteType).hashCode = function () {
    return NavigationSuiteType__hashCode_impl_nk8xvw(this.wxm_1);
  };
  protoOf(NavigationSuiteType).equals = function (other) {
    return NavigationSuiteType__equals_impl_jcu6s0(this.wxm_1, other);
  };
  function NavigationSuiteScaffold(navigationSuiteItems, modifier, layoutType, navigationSuiteColors, containerColor, contentColor, state, content, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var modifier_0 = {_v: modifier};
    var tmp = layoutType;
    var layoutType_0 = {_v: tmp == null ? null : new NavigationSuiteType(tmp)};
    var navigationSuiteColors_0 = {_v: navigationSuiteColors};
    var containerColor_0 = {_v: new Color(containerColor)};
    var contentColor_0 = {_v: new Color(contentColor)};
    var state_0 = {_v: state};
    var content_0 = {_v: content};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1187504617);
    sourceInformation($composer_0, 'C(NavigationSuiteScaffold)P(6,4,3:c#material3.adaptive.navigationsuite.NavigationSuiteType,5,0:c#ui.graphics.Color,2:c#ui.graphics.Color,7)269@13281L1664,269@13199L1746:NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(navigationSuiteItems) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(layoutType_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | (($default & 8) === 0 && $composer_0.k31(navigationSuiteColors_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(containerColor_0._v.c6d_1))) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | (($default & 32) === 0 && $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(contentColor_0._v.c6d_1))) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | (($default & 64) === 0 && $composer_0.k31(state_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(content_0._v) ? 8388608 : 4194304);
    if (!(($dirty & 4793491) === 4793490) || !$composer_0.i30()) {
      $composer_0.q30();
      sourceInformation($composer_0, '262@12806L25,263@12909L8,264@12979L14,265@13053L12,266@13109L38');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 4) === 0)) {
          layoutType_0._v = new NavigationSuiteType(NavigationSuiteScaffoldDefaults_getInstance().yxm(get_WindowAdaptiveInfoDefault($composer_0, 0)));
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          var tmp_0 = NavigationSuiteDefaults_getInstance();
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          navigationSuiteColors_0._v = tmp_0.axn(tmp_1, tmp_2, null, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 805306368, 511);
          $dirty = $dirty & -7169;
        }
        if (!(($default & 16) === 0)) {
          containerColor_0._v = new Color(NavigationSuiteScaffoldDefaults_getInstance().rnu($composer_0, 6));
          $dirty = $dirty & -57345;
        }
        if (!(($default & 32) === 0)) {
          contentColor_0._v = new Color(NavigationSuiteScaffoldDefaults_getInstance().gqd($composer_0, 6));
          $dirty = $dirty & -458753;
        }
        if (!(($default & 64) === 0)) {
          state_0._v = rememberNavigationSuiteScaffoldState(null, $composer_0, 0, 1);
          $dirty = $dirty & -3670017;
        }
        if (!(($default & 128) === 0)) {
          content_0._v = ComposableSingletons$NavigationSuiteScaffoldKt_getInstance().cxn_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
        if (!(($default & 8) === 0))
          $dirty = $dirty & -7169;
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
        if (!(($default & 32) === 0))
          $dirty = $dirty & -458753;
        if (!(($default & 64) === 0))
          $dirty = $dirty & -3670017;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-1187504617, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffold (NavigationSuiteScaffold.kt:268)');
      }
      var tmp_8 = modifier_0._v;
      var tmp_9 = containerColor_0._v;
      var tmp_10 = contentColor_0._v;
      var tmp_11 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_12 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1342772900, true, NavigationSuiteScaffold$lambda(layoutType_0, state_0, navigationSuiteColors_0, navigationSuiteItems, content_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_13;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_13 = value;
      } else {
        tmp_13 = it;
      }
      var tmp$ret$0 = tmp_13;
      Surface(tmp_8, null, tmp_9.c6d_1, tmp_10.c6d_1, tmp_11, tmp_12, null, tmp$ret$0, $composer_0, 12582912 | 14 & $dirty >> 3 | 896 & $dirty >> 6 | 7168 & $dirty >> 6, 114);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavigationSuiteScaffold$lambda_0(navigationSuiteItems, modifier_0, layoutType_0, navigationSuiteColors_0, containerColor_0, contentColor_0, state_0, content_0, $changed, $default));
    }
  }
  function NavigationSuiteScope() {
  }
  function NavigationSuiteColors(shortNavigationBarContainerColor, shortNavigationBarContentColor, wideNavigationRailColors, navigationBarContainerColor, navigationBarContentColor, navigationRailContainerColor, navigationRailContentColor, navigationDrawerContainerColor, navigationDrawerContentColor) {
    this.kxn_1 = shortNavigationBarContainerColor;
    this.lxn_1 = shortNavigationBarContentColor;
    this.mxn_1 = wideNavigationRailColors;
    this.nxn_1 = navigationBarContainerColor;
    this.oxn_1 = navigationBarContentColor;
    this.pxn_1 = navigationRailContainerColor;
    this.qxn_1 = navigationRailContentColor;
    this.rxn_1 = navigationDrawerContainerColor;
    this.sxn_1 = navigationDrawerContentColor;
  }
  function NavigationSuiteScaffoldDefaults() {
    NavigationSuiteScaffoldDefaults_instance = this;
    this.xxm_1 = Companion_getInstance_0().y8t_1;
  }
  protoOf(NavigationSuiteScaffoldDefaults).yxm = function (adaptiveInfo) {
    // Inline function 'kotlin.with' call
    var tmp;
    if (adaptiveInfo.cxm_1.zxl_1 || equals(get_minHeight(adaptiveInfo.bxm_1), get_HeightSizeClasses(Companion_getInstance_1()).txn_1) || equals(get_minWidth(adaptiveInfo.bxm_1), get_WidthSizeClasses(Companion_getInstance_1()).wxn_1)) {
      tmp = Companion_getInstance_5().sxm_1;
    } else {
      tmp = Companion_getInstance_5().txm_1;
    }
    return tmp;
  };
  protoOf(NavigationSuiteScaffoldDefaults).rnu = function ($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 609206223, 'C(<get-containerColor>)1202@55888L11:NavigationSuiteScaffold.kt#94yoxb');
    if (isTraceInProgress()) {
      traceEventStart(609206223, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffoldDefaults.<get-containerColor> (NavigationSuiteScaffold.kt:1202)');
    }
    var tmp0 = MaterialTheme_instance.unz($composer_0, androidx_compose_material3_MaterialTheme$stableprop_getter()).ko0_1;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  protoOf(NavigationSuiteScaffoldDefaults).gqd = function ($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -188869809, 'C(<get-contentColor>)1206@56048L11:NavigationSuiteScaffold.kt#94yoxb');
    if (isTraceInProgress()) {
      traceEventStart(-188869809, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffoldDefaults.<get-contentColor> (NavigationSuiteScaffold.kt:1206)');
    }
    var tmp0 = MaterialTheme_instance.unz($composer_0, androidx_compose_material3_MaterialTheme$stableprop_getter()).lo0_1;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  var NavigationSuiteScaffoldDefaults_instance;
  function NavigationSuiteScaffoldDefaults_getInstance() {
    if (NavigationSuiteScaffoldDefaults_instance == null)
      new NavigationSuiteScaffoldDefaults();
    return NavigationSuiteScaffoldDefaults_instance;
  }
  function get_WindowAdaptiveInfoDefault($composer, $changed) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -1528952560, 'C(<get-WindowAdaptiveInfoDefault>)1393@66068L27:NavigationSuiteScaffold.kt#94yoxb');
    if (isTraceInProgress()) {
      traceEventStart(-1528952560, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.<get-WindowAdaptiveInfoDefault> (NavigationSuiteScaffold.kt:1393)');
    }
    var tmp0 = currentWindowAdaptiveInfo($composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function NavigationSuiteDefaults() {
    NavigationSuiteDefaults_instance = this;
    this.zxm_1 = Arrangement_getInstance().sdp_1;
  }
  protoOf(NavigationSuiteDefaults).axn = function (shortNavigationBarContentColor, shortNavigationBarContainerColor, wideNavigationRailColors, navigationBarContainerColor, navigationBarContentColor, navigationRailContainerColor, navigationRailContentColor, navigationDrawerContainerColor, navigationDrawerContentColor, $composer, $changed, $default) {
    var shortNavigationBarContentColor_0 = shortNavigationBarContentColor;
    var shortNavigationBarContainerColor_0 = shortNavigationBarContainerColor;
    var wideNavigationRailColors_0 = wideNavigationRailColors;
    var navigationBarContainerColor_0 = navigationBarContainerColor;
    var navigationBarContentColor_0 = navigationBarContentColor;
    var navigationRailContainerColor_0 = navigationRailContainerColor;
    var navigationRailContentColor_0 = navigationRailContentColor;
    var navigationDrawerContainerColor_0 = navigationDrawerContainerColor;
    var navigationDrawerContentColor_0 = navigationDrawerContentColor;
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1149707882, 'C(colors)P(7:c#ui.graphics.Color,6:c#ui.graphics.Color,8,0:c#ui.graphics.Color,1:c#ui.graphics.Color,4:c#ui.graphics.Color,5:c#ui.graphics.Color,2:c#ui.graphics.Color,3:c#ui.graphics.Color)1239@57891L12,1240@57982L14,1241@58086L8,1242@58163L14,1243@58222L44,1244@58337L14,1245@58397L45,1247@58544L14,1248@58606L47:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($default & 1) === 0))
      shortNavigationBarContentColor_0 = ShortNavigationBarDefaults_instance.gqd($composer_0, androidx_compose_material3_ShortNavigationBarDefaults$stableprop_getter());
    if (!(($default & 2) === 0))
      shortNavigationBarContainerColor_0 = ShortNavigationBarDefaults_instance.rnu($composer_0, androidx_compose_material3_ShortNavigationBarDefaults$stableprop_getter());
    if (!(($default & 4) === 0))
      wideNavigationRailColors_0 = WideNavigationRailDefaults_getInstance().moj($composer_0, androidx_compose_material3_WideNavigationRailDefaults$stableprop_getter());
    if (!(($default & 8) === 0))
      navigationBarContainerColor_0 = NavigationBarDefaults_getInstance().rnu($composer_0, androidx_compose_material3_NavigationBarDefaults$stableprop_getter());
    if (!(($default & 16) === 0))
      navigationBarContentColor_0 = contentColorFor(navigationBarContainerColor_0, $composer_0, 14 & $changed >> 9);
    if (!(($default & 32) === 0))
      navigationRailContainerColor_0 = NavigationRailDefaults_instance.lpn($composer_0, androidx_compose_material3_NavigationRailDefaults$stableprop_getter());
    if (!(($default & 64) === 0))
      navigationRailContentColor_0 = contentColorFor(navigationRailContainerColor_0, $composer_0, 14 & $changed >> 15);
    if (!(($default & 128) === 0))
      navigationDrawerContainerColor_0 = DrawerDefaults_getInstance().rnu($composer_0, androidx_compose_material3_DrawerDefaults$stableprop_getter());
    if (!(($default & 256) === 0))
      navigationDrawerContentColor_0 = contentColorFor(navigationDrawerContainerColor_0, $composer_0, 14 & $changed >> 21);
    if (isTraceInProgress()) {
      traceEventStart(1149707882, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteDefaults.colors (NavigationSuiteScaffold.kt:1250)');
    }
    var tmp0 = new NavigationSuiteColors(shortNavigationBarContainerColor_0, shortNavigationBarContentColor_0, wideNavigationRailColors_0, navigationBarContainerColor_0, navigationBarContentColor_0, navigationRailContainerColor_0, navigationRailContentColor_0, navigationDrawerContainerColor_0, navigationDrawerContentColor_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  protoOf(NavigationSuiteDefaults).bxo = function (navigationBarItemColors, navigationRailItemColors, navigationDrawerItemColors, $composer, $changed, $default) {
    var navigationBarItemColors_0 = navigationBarItemColors;
    var navigationRailItemColors_0 = navigationRailItemColors;
    var navigationDrawerItemColors_0 = navigationDrawerItemColors;
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 97096824, 'C(itemColors)P(!1,2)1323@62896L8,1324@62994L8,1326@63110L8:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($default & 1) === 0))
      navigationBarItemColors_0 = NavigationBarItemDefaults_instance.moj($composer_0, androidx_compose_material3_NavigationBarItemDefaults$stableprop_getter());
    if (!(($default & 2) === 0))
      navigationRailItemColors_0 = NavigationRailItemDefaults_instance.moj($composer_0, androidx_compose_material3_NavigationRailItemDefaults$stableprop_getter());
    if (!(($default & 4) === 0)) {
      var tmp = NavigationDrawerItemDefaults_getInstance();
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      navigationDrawerItemColors_0 = tmp.ypw(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, androidx_compose_material3_NavigationDrawerItemDefaults$stableprop_getter() << 24, 255);
    }
    if (isTraceInProgress()) {
      traceEventStart(97096824, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteDefaults.itemColors (NavigationSuiteScaffold.kt:1328)');
    }
    var tmp0 = new NavigationSuiteItemColors(navigationBarItemColors_0, navigationRailItemColors_0, navigationDrawerItemColors_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  var NavigationSuiteDefaults_instance;
  function NavigationSuiteDefaults_getInstance() {
    if (NavigationSuiteDefaults_instance == null)
      new NavigationSuiteDefaults();
    return NavigationSuiteDefaults_instance;
  }
  function rememberNavigationSuiteScaffoldState(initialValue, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var initialValue_0 = {_v: initialValue};
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1384658993, 'C(rememberNavigationSuiteScaffoldState)144@6397L77,144@6330L144:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($default & 1) === 0)) {
      initialValue_0._v = NavigationSuiteScaffoldValue_Visible_getInstance();
    }
    if (isTraceInProgress()) {
      traceEventStart(1384658993, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.rememberNavigationSuiteScaffoldState (NavigationSuiteScaffold.kt:143)');
    }
    var tmp = Companion_instance_1.exo();
    sourceInformationMarkerStart($composer_0, -782561346, 'CC(remember):NavigationSuiteScaffold.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.m31(initialValue_0._v.a1_1) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = rememberNavigationSuiteScaffoldState$lambda(initialValue_0);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp1_group = tmp_0;
    sourceInformationMarkerEnd($composer_0);
    var tmp0 = rememberSaveable([], tmp, tmp1_group, $composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1164008505$lambda_u6nr5h($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-1164008505, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$-1164008505.<anonymous> (NavigationSuiteScaffold.kt:202)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$568924554$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(568924554, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$568924554.<anonymous> (NavigationSuiteScaffold.kt:267)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1866128853$lambda_vpeww5($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-1866128853, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$-1866128853.<anonymous> (NavigationSuiteScaffold.kt:342)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_492711772$lambda_teh3wd($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-492711772, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$-492711772.<anonymous> (NavigationSuiteScaffold.kt:381)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1548300991$lambda_xra56t($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-1548300991, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$-1548300991.<anonymous> (NavigationSuiteScaffold.kt:505)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1305500908$lambda_awafqw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-1305500908, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$-1305500908.<anonymous> (NavigationSuiteScaffold.kt:536)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt$lambda$895267259$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
    if (!(($changed & 3) === 2) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(895267259, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.ComposableSingletons$NavigationSuiteScaffoldKt.lambda$895267259.<anonymous> (NavigationSuiteScaffold.kt:574)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$NavigationSuiteScaffoldKt() {
    ComposableSingletons$NavigationSuiteScaffoldKt_instance = this;
    var tmp = this;
    tmp.bxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1164008505, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1164008505$lambda_u6nr5h));
    var tmp_0 = this;
    tmp_0.cxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(568924554, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$568924554$lambda));
    var tmp_1 = this;
    tmp_1.dxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1866128853, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1866128853$lambda_vpeww5));
    var tmp_2 = this;
    tmp_2.exn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-492711772, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_492711772$lambda_teh3wd));
    var tmp_3 = this;
    tmp_3.fxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1548300991, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1548300991$lambda_xra56t));
    var tmp_4 = this;
    tmp_4.gxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1305500908, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$_1305500908$lambda_awafqw));
    var tmp_5 = this;
    tmp_5.hxn_1 = ComposableLambda$invoke$ref(composableLambdaInstance(895267259, false, ComposableSingletons$NavigationSuiteScaffoldKt$lambda$895267259$lambda));
  }
  var ComposableSingletons$NavigationSuiteScaffoldKt_instance;
  function ComposableSingletons$NavigationSuiteScaffoldKt_getInstance() {
    if (ComposableSingletons$NavigationSuiteScaffoldKt_instance == null)
      new ComposableSingletons$NavigationSuiteScaffoldKt();
    return ComposableSingletons$NavigationSuiteScaffoldKt_instance;
  }
  function NavigationSuiteScaffoldLayout(navigationSuite, layoutType, state, content, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var tmp = layoutType;
    var layoutType_0 = {_v: tmp == null ? null : new NavigationSuiteType(tmp)};
    var state_0 = {_v: state};
    var content_0 = {_v: content};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-67066668);
    sourceInformation($composer_0, 'C(NavigationSuiteScaffoldLayout)P(2,1:c#material3.adaptive.navigationsuite.NavigationSuiteType,3)507@24742L171:NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(navigationSuite) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | (($default & 2) === 0 && $composer_0.k31(layoutType_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(state_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content_0._v) ? 2048 : 1024);
    if (!(($dirty & 1171) === 1170) || !$composer_0.i30()) {
      $composer_0.q30();
      sourceInformation($composer_0, '503@24582L25,504@24652L38');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          layoutType_0._v = new NavigationSuiteType(NavigationSuiteScaffoldDefaults_getInstance().yxm(get_WindowAdaptiveInfoDefault($composer_0, 0)));
          $dirty = $dirty & -113;
        }
        if (!(($default & 4) === 0)) {
          state_0._v = rememberNavigationSuiteScaffoldState(null, $composer_0, 0, 1);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          content_0._v = ComposableSingletons$NavigationSuiteScaffoldKt_getInstance().fxn_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-67066668, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffoldLayout (NavigationSuiteScaffold.kt:506)');
      }
      var tmp_0 = layoutType_0._v;
      var tmp_1 = state_0._v;
      NavigationSuiteScaffoldLayout_0(navigationSuite, tmp_0.wxm_1, tmp_1, null, null, content_0._v, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 458752 & $dirty << 6, 24);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavigationSuiteScaffoldLayout$lambda(navigationSuite, layoutType_0, state_0, content_0, $changed, $default));
    }
  }
  function NavigationSuite(modifier, layoutType, colors, content, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var modifier_0 = {_v: modifier};
    var tmp = layoutType;
    var layoutType_0 = {_v: tmp == null ? null : new NavigationSuiteType(tmp)};
    var colors_0 = {_v: colors};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1682834171);
    sourceInformation($composer_0, 'C(NavigationSuite)P(3,2:c#material3.adaptive.navigationsuite.NavigationSuiteType)701@33404L29,704@33678L12:NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | (($default & 2) === 0 && $composer_0.k31(layoutType_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(colors_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if (!(($dirty & 1171) === 1170) || !$composer_0.i30()) {
      $composer_0.q30();
      sourceInformation($composer_0, '697@33239L25,698@33327L8');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 2) === 0)) {
          layoutType_0._v = new NavigationSuiteType(NavigationSuiteScaffoldDefaults_getInstance().yxm(get_WindowAdaptiveInfoDefault($composer_0, 0)));
          $dirty = $dirty & -113;
        }
        if (!(($default & 4) === 0)) {
          var tmp_0 = NavigationSuiteDefaults_getInstance();
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          colors_0._v = tmp_0.axn(tmp_1, tmp_2, null, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 805306368, 511);
          $dirty = $dirty & -897;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(1682834171, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite (NavigationSuiteScaffold.kt:700)');
      }
      var scope$delegate = rememberStateOfItems(content, $composer_0, 14 & $dirty >> 9);
      var tmp_8 = NavigationSuiteDefaults_getInstance();
      var defaultItemColors = tmp_8.bxo(null, null, null, $composer_0, 3072, 7);
      var tmp0_subject = layoutType_0._v.wxm_1;
      if (tmp0_subject === Companion_getInstance_5().sxm_1) {
        $composer_0.m30(-1839739117);
        sourceInformation($composer_0, '712@33975L756,708@33775L956');
        var tmp_9 = modifier_0._v;
        var tmp_10 = colors_0._v.nxn_1;
        var tmp_11 = colors_0._v.oxn_1;
        var tmp_12 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1321804314, true, NavigationSuite$lambda_0(defaultItemColors, scope$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_13;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_0(dispatchReceiver);
          $composer_1.j31(value);
          tmp_13 = value;
        } else {
          tmp_13 = it;
        }
        var tmp$ret$0 = tmp_13;
        NavigationBar(tmp_9, tmp_10, tmp_11, tmp_12, null, tmp$ret$0, $composer_0, 196608 | 14 & $dirty, 24);
        $composer_0.n30();
      } else if (tmp0_subject === Companion_getInstance_5().txm_1) {
        $composer_0.m30(-1838720147);
        sourceInformation($composer_0, '735@35005L759,731@34802L962');
        var tmp_14 = modifier_0._v;
        var tmp_15 = colors_0._v.pxn_1;
        var tmp_16 = colors_0._v.qxn_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1396067268, true, NavigationSuite$lambda_1(defaultItemColors, scope$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_17;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_17 = value_0;
        } else {
          tmp_17 = it_0;
        }
        var tmp$ret$7 = tmp_17;
        NavigationRail(tmp_14, tmp_15, tmp_16, null, null, tmp$ret$7, $composer_0, 196608 | 14 & $dirty, 24);
        $composer_0.n30();
      } else if (tmp0_subject === Companion_getInstance_5().uxm_1) {
        $composer_0.m30(-1837695318);
        sourceInformation($composer_0, '758@36062L676,754@35837L901');
        var tmp_18 = modifier_0._v;
        var tmp_19 = colors_0._v.rxn_1;
        var tmp_20 = colors_0._v.sxn_1;
        var tmp_21 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-1884440258, true, NavigationSuite$lambda_2(defaultItemColors, scope$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_3.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_3.i31();
        var tmp_22;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
          $composer_3.j31(value_1);
          tmp_22 = value_1;
        } else {
          tmp_22 = it_1;
        }
        var tmp$ret$14 = tmp_22;
        PermanentDrawerSheet(tmp_18, null, tmp_19, tmp_20, tmp_21, null, tmp$ret$14, $composer_0, 1572864 | 14 & $dirty, 50);
        $composer_0.n30();
      } else if (tmp0_subject === Companion_getInstance_5().vxm_1) {
        $composer_0.m30(-1836768418);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1836681711);
        sourceInformation($composer_0, '783@37008L807,779@36857L958');
        var tmp_23 = layoutType_0._v;
        var tmp_24 = modifier_0._v;
        var tmp_25 = colors_0._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(-69522256, true, NavigationSuite$lambda_3(layoutType_0, scope$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_4.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_4.i31();
        var tmp_26;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_4.j31(value_2);
          tmp_26 = value_2;
        } else {
          tmp_26 = it_2;
        }
        var tmp$ret$21 = tmp_26;
        NavigationSuite_0(tmp_23.wxm_1, tmp_24, tmp_25, null, null, tmp$ret$21, $composer_0, 196608 | 14 & $dirty >> 3 | 112 & $dirty << 3 | 896 & $dirty, 24);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavigationSuite$lambda_4(modifier_0, layoutType_0, colors_0, content, $changed, $default));
    }
  }
  var NavigationSuiteScaffoldValue_Visible_instance;
  var NavigationSuiteScaffoldValue_Hidden_instance;
  var NavigationSuiteScaffoldValue_entriesInitialized;
  function NavigationSuiteScaffoldValue_initEntries() {
    if (NavigationSuiteScaffoldValue_entriesInitialized)
      return Unit_instance;
    NavigationSuiteScaffoldValue_entriesInitialized = true;
    NavigationSuiteScaffoldValue_Visible_instance = new NavigationSuiteScaffoldValue('Visible', 0);
    NavigationSuiteScaffoldValue_Hidden_instance = new NavigationSuiteScaffoldValue('Hidden', 1);
  }
  function NavigationSuiteScaffoldValue(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NavigationSuiteItemColors(navigationBarItemColors, navigationRailItemColors, navigationDrawerItemColors) {
    this.fxo_1 = navigationBarItemColors;
    this.gxo_1 = navigationRailItemColors;
    this.hxo_1 = navigationDrawerItemColors;
  }
  function NavigationSuiteScaffoldStateImpl$Companion$Saver$lambda($this$Saver, it) {
    return it.sea();
  }
  function NavigationSuiteScaffoldStateImpl$Companion$Saver$lambda_0(it) {
    return new NavigationSuiteScaffoldStateImpl(it);
  }
  function Companion_0() {
    this.cxo_1 = 0.0;
    this.dxo_1 = 1.0;
  }
  protoOf(Companion_0).exo = function () {
    var tmp = NavigationSuiteScaffoldStateImpl$Companion$Saver$lambda;
    return Saver(tmp, NavigationSuiteScaffoldStateImpl$Companion$Saver$lambda_0);
  };
  var Companion_instance_1;
  function Companion_getInstance_6() {
    return Companion_instance_1;
  }
  function NavigationSuiteScaffoldStateImpl$_currentVal$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.kxo_1.u1() === 1.0) {
        tmp = NavigationSuiteScaffoldValue_Visible_getInstance();
      } else {
        tmp = NavigationSuiteScaffoldValue_Hidden_getInstance();
      }
      return tmp;
    };
  }
  function NavigationSuiteScaffoldStateImpl(initialValue) {
    this.ixo_1 = initialValue;
    this.jxo_1 = get_isVisible(this.ixo_1) ? 1.0 : 0.0;
    this.kxo_1 = new Animatable(this.jxo_1, get_VectorConverter(FloatCompanionObject_instance));
    var tmp = this;
    tmp.lxo_1 = derivedStateOf(NavigationSuiteScaffoldStateImpl$_currentVal$lambda(this));
  }
  protoOf(NavigationSuiteScaffoldStateImpl).mxo = function () {
    return this.kxo_1.rea();
  };
  protoOf(NavigationSuiteScaffoldStateImpl).sea = function () {
    var tmp;
    if (this.kxo_1.sea() === 1.0) {
      tmp = NavigationSuiteScaffoldValue_Visible_getInstance();
    } else {
      tmp = NavigationSuiteScaffoldValue_Hidden_getInstance();
    }
    return tmp;
  };
  protoOf(NavigationSuiteScaffoldStateImpl).i3a = function () {
    return this.lxo_1.u1();
  };
  function NavigationSuiteScaffoldLayout_0(navigationSuite, navigationSuiteType, state, primaryActionContent, primaryActionContentHorizontalAlignment, content, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var state_0 = {_v: state};
    var primaryActionContent_0 = {_v: primaryActionContent};
    var primaryActionContentHorizontalAlignment_0 = {_v: primaryActionContentHorizontalAlignment};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-262937133);
    sourceInformation($composer_0, 'C(NavigationSuiteScaffoldLayout)P(1,2:c#material3.adaptive.navigationsuite.NavigationSuiteType,5,3,4)387@18966L174,398@19576L3973,392@19146L4403:NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(navigationSuite) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(_get_description__4f1tkb(navigationSuiteType)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(state_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(primaryActionContent_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(primaryActionContentHorizontalAlignment_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if (!(($dirty & 74899) === 74898) || !$composer_0.i30()) {
      $composer_0.q30();
      sourceInformation($composer_0, '380@18652L38');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          state_0._v = rememberNavigationSuiteScaffoldState(null, $composer_0, 0, 1);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          primaryActionContent_0._v = ComposableSingletons$NavigationSuiteScaffoldKt_getInstance().exn_1;
        }
        if (!(($default & 16) === 0)) {
          primaryActionContentHorizontalAlignment_0._v = NavigationSuiteScaffoldDefaults_getInstance().xxm_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-262937133, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffoldLayout (NavigationSuiteScaffold.kt:385)');
      }
      var tmp = state_0._v.i3a().equals(NavigationSuiteScaffoldValue_Hidden_getInstance()) ? 0.0 : 1.0;
      var tmp_0 = get_AnimationSpec();
      var animationProgress$delegate = animateFloatAsState(tmp, tmp_0, 0.0, null, null, $composer_0, 48, 28);
      sourceInformationMarkerStart($composer_0, 720524952, 'CC(remember):NavigationSuiteScaffold.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(($dirty & 112) === 32 | $composer_0.k31(animationProgress$delegate)) | ($dirty & 57344) === 16384);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var tmp_2 = NavigationSuiteScaffoldLayout$lambda_1(navigationSuiteType, animationProgress$delegate, primaryActionContentHorizontalAlignment_0);
        var value = new sam$androidx_compose_ui_layout_MeasurePolicy$0(tmp_2);
        tmp0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier = null;
      var $composer_1 = $composer_0;
      if (!((2 & 2) === 0))
        modifier = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var localMap = $composer_1.t31();
      var materialized = materialize($composer_1, modifier);
      var tmp0_0 = Companion_getInstance_2().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_2 = $composer_1;
      var tmp_3 = $composer_2.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(tmp0_0);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp0_group, Companion_getInstance_2().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_2().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_2().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_2().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_2().qah_1);
      var $composer_3 = $composer_2;
      sourceInformationMarkerStart($composer_3, 703199363, 'C395@19340L72,396@19421L82,397@19512L56:NavigationSuiteScaffold.kt#94yoxb');
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_0 = layoutId(Companion_instance, 'navigationSuite');
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_4 = $composer_3;
      if (!((6 & 1) === 0))
        modifier_0 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_0().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_1 = modifier_0;
      var $composer_5 = $composer_4;
      if (!((0 & 2) === 0))
        modifier_1 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_5, 0).hashCode();
      var localMap_0 = $composer_5.t31();
      var materialized_0 = materialize($composer_5, modifier_1);
      var tmp0_1 = Companion_getInstance_2().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_6 = $composer_5;
      var tmp_4 = $composer_6.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_6.b31();
      if ($composer_6.h30()) {
        $composer_6.c31(tmp0_1);
      } else {
        $composer_6.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_6);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy, Companion_getInstance_2().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_2().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_2().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_2().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_2().qah_1);
      var $composer_7 = $composer_6;
      var $composer_8 = $composer_7;
      sourceInformationMarkerStart($composer_8, -379479780, 'C395@19393L17:NavigationSuiteScaffold.kt#94yoxb');
      navigationSuite($composer_8, 14 & $dirty);
      sourceInformationMarkerEnd($composer_8);
      $composer_6.e31();
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_2 = layoutId(Companion_instance, 'primaryActionContent');
      var contentAlignment_0 = null;
      var propagateMinConstraints_0 = false;
      var $composer_9 = $composer_3;
      if (!((6 & 1) === 0))
        modifier_2 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_0 = Companion_getInstance_0().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_0 = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_3 = modifier_2;
      var $composer_10 = $composer_9;
      if (!((0 & 2) === 0))
        modifier_3 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_10, 0).hashCode();
      var localMap_1 = $composer_10.t31();
      var materialized_1 = materialize($composer_10, modifier_3);
      var tmp0_2 = Companion_getInstance_2().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_11 = $composer_10;
      var tmp_5 = $composer_11.g30();
      if (!isInterface(tmp_5, Applier)) {
        invalidApplier();
      }
      $composer_11.b31();
      if ($composer_11.h30()) {
        $composer_11.c31(tmp0_2);
      } else {
        $composer_11.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_11);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_0, Companion_getInstance_2().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_2().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_2().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_2().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_2().qah_1);
      var $composer_12 = $composer_11;
      var $composer_13 = $composer_12;
      sourceInformationMarkerStart($composer_13, 666907118, 'C396@19479L22:NavigationSuiteScaffold.kt#94yoxb');
      primaryActionContent_0._v($composer_13, 14 & $dirty >> 9);
      sourceInformationMarkerEnd($composer_13);
      $composer_11.e31();
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_4 = layoutId(Companion_instance, 'content');
      var contentAlignment_1 = null;
      var propagateMinConstraints_1 = false;
      var $composer_14 = $composer_3;
      if (!((6 & 1) === 0))
        modifier_4 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_1 = Companion_getInstance_0().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_1 = false;
      var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_5 = modifier_4;
      var $composer_15 = $composer_14;
      if (!((0 & 2) === 0))
        modifier_5 = Companion_instance;
      var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_15, 0).hashCode();
      var localMap_2 = $composer_15.t31();
      var materialized_2 = materialize($composer_15, modifier_5);
      var tmp0_3 = Companion_getInstance_2().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_16 = $composer_15;
      var tmp_6 = $composer_16.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_16.b31();
      if ($composer_16.h30()) {
        $composer_16.c31(tmp0_3);
      } else {
        $composer_16.d31();
      }
      var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_16);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_1, Companion_getInstance_2().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_2().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_2().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_2().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_2().qah_1);
      var $composer_17 = $composer_16;
      var $composer_18 = $composer_17;
      sourceInformationMarkerStart($composer_18, -1080111076, 'C397@19557L9:NavigationSuiteScaffold.kt#94yoxb');
      content($composer_18, 14 & $dirty >> 15);
      sourceInformationMarkerEnd($composer_18);
      $composer_16.e31();
      sourceInformationMarkerEnd($composer_3);
      $composer_2.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(NavigationSuiteScaffoldLayout$lambda_2(navigationSuite, navigationSuiteType, state_0, primaryActionContent_0, primaryActionContentHorizontalAlignment_0, content, $changed, $default));
    }
  }
  function rememberStateOfItems(content, $composer, $changed) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -480927766, 'C(rememberStateOfItems)1548@71581L29,1549@71622L85:NavigationSuiteScaffold.kt#94yoxb');
    if (isTraceInProgress()) {
      traceEventStart(-480927766, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.rememberStateOfItems (NavigationSuiteScaffold.kt:1547)');
    }
    var latestContent = rememberUpdatedState(content, $composer_0, 14 & $changed);
    sourceInformationMarkerStart($composer_0, 1684891199, 'CC(remember):NavigationSuiteScaffold.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = derivedStateOf(rememberStateOfItems$lambda(latestContent));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp1_group;
  }
  function NavigationSuiteItem(selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource) {
    this.nxo_1 = selected;
    this.oxo_1 = onClick;
    this.pxo_1 = icon;
    this.qxo_1 = modifier;
    this.rxo_1 = enabled;
    this.sxo_1 = label;
    this.txo_1 = alwaysShowLabel;
    this.uxo_1 = badge;
    this.vxo_1 = colors;
    this.wxo_1 = interactionSource;
  }
  function NavigationItemIcon(icon, badge, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var badge_0 = {_v: badge};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2056950107);
    sourceInformation($composer_0, 'C(NavigationItemIcon)P(1):NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(icon) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(badge_0._v) ? 32 : 16);
    if (!(($dirty & 19) === 18) || !$composer_0.i30()) {
      if (!(($default & 2) === 0)) {
        badge_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(2056950107, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationItemIcon (NavigationSuiteScaffold.kt:1556)');
      }
      if (!(badge_0._v == null)) {
        $composer_0.m30(-1992590905);
        sourceInformation($composer_0, '1558@71889L18,1558@71909L10,1558@71871L48');
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-427323906, true, NavigationItemIcon$lambda(badge_0), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_2(dispatchReceiver);
          $composer_1.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp_0 = tmp;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1775457476, true, NavigationItemIcon$lambda_0(icon), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_2(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$7 = tmp_1;
        BadgedBox(tmp_0, null, tmp$ret$7, $composer_0, 390, 2);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1992522767);
        sourceInformation($composer_0, '1560@71941L6');
        icon($composer_0, 14 & $dirty);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavigationItemIcon$lambda_1(icon, badge_0, $changed, $default));
    }
  }
  function NavigationSuite_0(navigationSuiteType, modifier, colors, verticalArrangement, primaryActionContent, content, $composer, $changed, $default) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var modifier_0 = {_v: modifier};
    var colors_0 = {_v: colors};
    var verticalArrangement_0 = {_v: verticalArrangement};
    var primaryActionContent_0 = {_v: primaryActionContent};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2037891754);
    sourceInformation($composer_0, 'C(NavigationSuite)P(3:c#material3.adaptive.navigationsuite.NavigationSuiteType,2!1,5,4)577@27968L47:NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(_get_description__4f1tkb(navigationSuiteType)) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(colors_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(verticalArrangement_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(primaryActionContent_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if (!(($dirty & 74899) === 74898) || !$composer_0.i30()) {
      $composer_0.q30();
      sourceInformation($composer_0, '572@27742L8');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 4) === 0)) {
          var tmp = NavigationSuiteDefaults_getInstance();
          var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          colors_0._v = tmp.axn(tmp_0, tmp_1, null, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 805306368, 511);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          verticalArrangement_0._v = NavigationSuiteDefaults_getInstance().zxm_1;
        }
        if (!(($default & 16) === 0)) {
          primaryActionContent_0._v = ComposableSingletons$NavigationSuiteScaffoldKt_getInstance().hxn_1;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(2037891754, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite (NavigationSuiteScaffold.kt:576)');
      }
      sourceInformationMarkerStart($composer_0, -91098535, 'CC(remember):NavigationSuiteScaffold.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 458752) === 131072;
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_7;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = movableContentOf(content);
        tmp0.j31(value);
        tmp_7 = value;
      } else {
        tmp_7 = it;
      }
      var tmp0_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var movableContent = tmp0_group;
      if (navigationSuiteType === Companion_getInstance_5().oxm_1) {
        $composer_0.m30(1471056832);
        sourceInformation($composer_0, '580@28120L256');
        var tmp_8 = modifier_0._v;
        var tmp_9 = colors_0._v.kxn_1;
        var tmp_10 = colors_0._v.lxn_1;
        ShortNavigationBar(tmp_8, tmp_9, tmp_10, null, null, movableContent, $composer_0, 14 & $dirty >> 3, 24);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().pxm_1) {
        $composer_0.m30(1471391136);
        sourceInformation($composer_0, '588@28457L256');
        var tmp_11 = modifier_0._v;
        var tmp_12 = colors_0._v.kxn_1;
        var tmp_13 = colors_0._v.lxn_1;
        ShortNavigationBar(tmp_11, tmp_12, tmp_13, null, null, movableContent, $composer_0, 14 & $dirty >> 3, 24);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().qxm_1) {
        $composer_0.m30(1471728788);
        sourceInformation($composer_0, '596@28797L268');
        var tmp1_colors = colors_0._v.mxn_1;
        var tmp_14 = modifier_0._v;
        var tmp_15 = primaryActionContent_0._v;
        WideNavigationRail(tmp_14, null, null, tmp1_colors, tmp_15, null, verticalArrangement_0._v, movableContent, $composer_0, 14 & $dirty >> 3 | 57344 & $dirty | 3670016 & $dirty << 9, 38);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().rxm_1) {
        $composer_0.m30(1472082312);
        sourceInformation($composer_0, '609@29296L126,605@29148L440');
        var tmp2_state = rememberWideNavigationRailState(WideNavigationRailValue_Expanded_getInstance(), $composer_0, 6, 0);
        var tmp3_colors = colors_0._v.mxn_1;
        var tmp_16 = modifier_0._v;
        var tmp_17 = primaryActionContent_0._v;
        WideNavigationRail(tmp_16, tmp2_state, null, tmp3_colors, tmp_17, null, verticalArrangement_0._v, movableContent, $composer_0, 14 & $dirty >> 3 | 57344 & $dirty | 3670016 & $dirty << 9, 36);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().sxm_1) {
        $composer_0.m30(1472910818);
        sourceInformation($composer_0, '622@29988L286');
        var tmp_18 = heightIn(modifier_0._v, get_TallNavigationBarHeight());
        var tmp_19 = colors_0._v.nxn_1;
        var tmp_20 = colors_0._v.oxn_1;
        ShortNavigationBar(tmp_18, tmp_19, tmp_20, null, null, movableContent, $composer_0, 0, 24);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().txm_1) {
        $composer_0.m30(1473406911);
        sourceInformation($composer_0, '634@30554L26,637@30732L417,632@30476L673');
        var tmp4_containerColor = colors_0._v.pxn_1;
        var tmp5_contentColor = colors_0._v.qxn_1;
        var tmp_21 = modifier_0._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(872457991, true, NavigationSuite$lambda_5(primaryActionContent_0), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_22;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_22 = value_0;
        } else {
          tmp_22 = it_0;
        }
        var tmp_23 = tmp_22;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(172391621, true, NavigationSuite$lambda_6(verticalArrangement_0, movableContent), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_2.i31();
        var tmp_24;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
          $composer_2.j31(value_1);
          tmp_24 = value_1;
        } else {
          tmp_24 = it_1;
        }
        var tmp$ret$11 = tmp_24;
        NavigationRail(tmp_21, tmp4_containerColor, tmp5_contentColor, tmp_23, null, tmp$ret$11, $composer_0, 199680 | 14 & $dirty >> 3, 16);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().uxm_1) {
        $composer_0.m30(1474279127);
        sourceInformation($composer_0, '657@31580L456,653@31355L681');
        var tmp_25 = modifier_0._v;
        var tmp_26 = colors_0._v.rxn_1;
        var tmp_27 = colors_0._v.sxn_1;
        var tmp_28 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-1983694325, true, NavigationSuite$lambda_7(primaryActionContent_0, verticalArrangement_0, movableContent), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_3.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_3.i31();
        var tmp_29;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
          $composer_3.j31(value_2);
          tmp_29 = value_2;
        } else {
          tmp_29 = it_2;
        }
        var tmp$ret$18 = tmp_29;
        PermanentDrawerSheet(tmp_25, null, tmp_26, tmp_27, tmp_28, null, tmp$ret$18, $composer_0, 1572864 | 14 & $dirty >> 3, 50);
        $composer_0.n30();
      } else {
        $composer_0.m30(1474962584);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(NavigationSuite$lambda_8(navigationSuiteType, modifier_0, colors_0, verticalArrangement_0, primaryActionContent_0, content, $changed, $default));
    }
  }
  function NavigationSuiteItem_0(isNavigationSuite, navigationSuiteType, selected, onClick, icon, label, modifier, enabled, badge, navigationItemColors, navigationSuiteItemColors, interactionSource, $composer, $changed, $changed1) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1803214535);
    sourceInformation($composer_0, 'C(NavigationSuiteItem)P(4,9:c#material3.adaptive.navigationsuite.NavigationSuiteType,11,10,2,5,6,1!1,7,8):NavigationSuiteScaffold.kt#94yoxb');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(isNavigationSuite) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(_get_description__4f1tkb(navigationSuiteType)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(selected) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(icon) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(label) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(badge) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(navigationItemColors) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(navigationSuiteItemColors) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(interactionSource) ? 32 : 16);
    if (!(($dirty & 306783379) === 306783378) || !(($dirty1 & 19) === 18) || !$composer_0.i30()) {
      if (isTraceInProgress()) {
        traceEventStart(-1803214535, $dirty, $dirty1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem (NavigationSuiteScaffold.kt:875)');
      }
      if (navigationSuiteType === Companion_getInstance_5().oxm_1 || navigationSuiteType === Companion_getInstance_5().pxm_1) {
        $composer_0.m30(1887378022);
        sourceInformation($composer_0, '888@41411L50,885@41292L477');
        var tmp;
        if (navigationSuiteType === Companion_getInstance_5().oxm_1) {
          tmp = Companion_getInstance_3().fpy_1;
        } else {
          tmp = Companion_getInstance_3().gpy_1;
        }
        var iconPosition = tmp;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-715321418, true, NavigationSuiteItem$lambda(icon, badge), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp_1 = tmp_0;
        var tmp_2;
        if (navigationItemColors == null) {
          $composer_0.m30(-2017305727);
          sourceInformation($composer_0, '893@41691L8');
          var tmp0_group = ShortNavigationBarItemDefaults_instance.moj($composer_0, androidx_compose_material3_ShortNavigationBarItemDefaults$stableprop_getter());
          $composer_0.n30();
          tmp_2 = tmp0_group;
        } else {
          $composer_0.m30(-2017307432);
          $composer_0.n30();
          tmp_2 = navigationItemColors;
        }
        ShortNavigationBarItem(selected, onClick, tmp_1, label, modifier, enabled, iconPosition, tmp_2, interactionSource, $composer_0, 384 | 14 & $dirty >> 6 | 112 & $dirty >> 6 | 7168 & $dirty >> 6 | 57344 & $dirty >> 6 | 458752 & $dirty >> 6 | 234881024 & $dirty1 << 21, 0);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().qxm_1 || navigationSuiteType === Companion_getInstance_5().rxm_1) {
        $composer_0.m30(1888251943);
        sourceInformation($composer_0, '904@42150L50,899@41909L554');
        var tmp3_railExpanded = navigationSuiteType === Companion_getInstance_5().rxm_1;
        var tmp_3;
        if (navigationItemColors == null) {
          $composer_0.m30(-2017283519);
          sourceInformation($composer_0, '908@42385L8');
          var tmp1_group = WideNavigationRailItemDefaults_instance.moj($composer_0, androidx_compose_material3_WideNavigationRailItemDefaults$stableprop_getter());
          $composer_0.n30();
          tmp_3 = tmp1_group;
        } else {
          $composer_0.m30(-2017285224);
          $composer_0.n30();
          tmp_3 = navigationItemColors;
        }
        var tmp4_colors = tmp_3;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(929903317, true, NavigationSuiteItem$lambda_0(icon, badge), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp_5 = tmp_4;
        WideNavigationRailItem(selected, onClick, tmp_5, label, tmp3_railExpanded, modifier, enabled, null, tmp4_colors, interactionSource, $composer_0, 384 | 14 & $dirty >> 6 | 112 & $dirty >> 6 | 7168 & $dirty >> 6 | 458752 & $dirty >> 3 | 3670016 & $dirty >> 3 | 1879048192 & $dirty1 << 24, 128);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().sxm_1) {
        $composer_0.m30(1889297294);
        sourceInformation($composer_0, '939@44065L50,936@43946L401');
        var tmp6_elvis_lhs = navigationSuiteItemColors == null ? null : navigationSuiteItemColors.fxo_1;
        var tmp_6;
        if (tmp6_elvis_lhs == null) {
          $composer_0.m30(-2017261535);
          sourceInformation($composer_0, '920@43072L8');
          var tmp2_group = NavigationBarItemDefaults_instance.moj($composer_0, androidx_compose_material3_NavigationBarItemDefaults$stableprop_getter());
          $composer_0.n30();
          tmp_6 = tmp2_group;
        } else {
          $composer_0.m30(-2017264635);
          $composer_0.n30();
          tmp_6 = tmp6_elvis_lhs;
        }
        var defaultColors = tmp_6;
        var tmp_7;
        if (!isNavigationSuite && navigationItemColors == null || isNavigationSuite) {
          $composer_0.m30(1889555896);
          sourceInformation($composer_0, '923@43260L586');
          var tmp3_group = ShortNavigationBarItemDefaults_instance.ypz(defaultColors.xpt_1, defaultColors.ypt_1, defaultColors.zpt_1, defaultColors.apu_1, defaultColors.bpu_1, defaultColors.cpu_1, defaultColors.dpu_1, $composer_0, androidx_compose_material3_ShortNavigationBarItemDefaults$stableprop_getter() << 21, 0);
          $composer_0.n30();
          tmp_7 = tmp3_group;
        } else {
          $composer_0.m30(1890195147);
          $composer_0.n30();
          tmp_7 = ensureNotNull(navigationItemColors);
        }
        var actualColors = tmp_7;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-217991490, true, NavigationSuiteItem$lambda_1(icon, badge), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_3.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_3.i31();
        var tmp_8;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_3.j31(value_1);
          tmp_8 = value_1;
        } else {
          tmp_8 = it_1;
        }
        var tmp_9 = tmp_8;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$21 = _Dp___init__impl__ms3zkb(8);
        var tmp_10 = padding(modifier, VOID, tmp$ret$21);
        ShortNavigationBarItem(selected, onClick, tmp_9, label, tmp_10, enabled, null, actualColors, interactionSource, $composer_0, 384 | 14 & $dirty >> 6 | 112 & $dirty >> 6 | 7168 & $dirty >> 6 | 458752 & $dirty >> 6 | 234881024 & $dirty1 << 21, 64);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().txm_1) {
        $composer_0.m30(1890901110);
        sourceInformation($composer_0, '972@45818L50,969@45703L377');
        var tmp_11;
        if (isNavigationSuite) {
          $composer_0.m30(1890929103);
          sourceInformation($composer_0, '');
          var tmp8_elvis_lhs = navigationSuiteItemColors == null ? null : navigationSuiteItemColors.gxo_1;
          var tmp_12;
          if (tmp8_elvis_lhs == null) {
            $composer_0.m30(-2017208319);
            sourceInformation($composer_0, '953@44735L8');
            var tmp4_group = NavigationRailItemDefaults_instance.moj($composer_0, androidx_compose_material3_NavigationRailItemDefaults$stableprop_getter());
            $composer_0.n30();
            tmp_12 = tmp4_group;
          } else {
            $composer_0.m30(-2017211605);
            $composer_0.n30();
            tmp_12 = tmp8_elvis_lhs;
          }
          var tmp7_group = tmp_12;
          $composer_0.n30();
          tmp_11 = tmp7_group;
        } else {
          $composer_0.m30(1891111662);
          sourceInformation($composer_0, '');
          var tmp_13;
          if (!(navigationItemColors == null)) {
            $composer_0.m30(1891161355);
            sourceInformation($composer_0, '956@44876L659');
            var tmp5_group = NavigationRailItemDefaults_instance.ypz(navigationItemColors.vpx_1, navigationItemColors.wpx_1, navigationItemColors.xpx_1, navigationItemColors.ypx_1, navigationItemColors.zpx_1, navigationItemColors.apy_1, navigationItemColors.bpy_1, $composer_0, androidx_compose_material3_NavigationRailItemDefaults$stableprop_getter() << 21, 0);
            $composer_0.n30();
            tmp_13 = tmp5_group;
          } else {
            $composer_0.m30(1891876060);
            sourceInformation($composer_0, '966@45613L12');
            var tmp_14 = NavigationSuiteDefaults_getInstance();
            var tmp6_group = tmp_14.bxo(null, null, null, $composer_0, 3072, 7).gxo_1;
            $composer_0.n30();
            tmp_13 = tmp6_group;
          }
          var tmp8_group = tmp_13;
          $composer_0.n30();
          tmp_11 = tmp8_group;
        }
        var actualColors_0 = tmp_11;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(2005188384, true, NavigationSuiteItem$lambda_2(icon, badge), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_4.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_4.i31();
        var tmp_15;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_4.j31(value_2);
          tmp_15 = value_2;
        } else {
          tmp_15 = it_2;
        }
        var tmp_16 = tmp_15;
        NavigationRailItem(selected, onClick, tmp_16, modifier, enabled, label, false, actualColors_0, interactionSource, $composer_0, 384 | 14 & $dirty >> 6 | 112 & $dirty >> 6 | 7168 & $dirty >> 9 | 57344 & $dirty >> 9 | 458752 & $dirty | 234881024 & $dirty1 << 21, 64);
        $composer_0.n30();
      } else if (navigationSuiteType === Companion_getInstance_5().uxm_1) {
        $composer_0.m30(1892618603);
        sourceInformation($composer_0, '1007@47496L31,1001@47281L355');
        var tmp_17;
        if (isNavigationSuite) {
          $composer_0.m30(1892652331);
          sourceInformation($composer_0, '');
          var tmp10_elvis_lhs = navigationSuiteItemColors == null ? null : navigationSuiteItemColors.hxo_1;
          var tmp_18;
          if (tmp10_elvis_lhs == null) {
            $composer_0.m30(-2017152607);
            sourceInformation($composer_0, '986@46476L8');
            var tmp_19 = NavigationDrawerItemDefaults_getInstance();
            var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_24 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_26 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp9_group = tmp_19.ypw(tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, androidx_compose_material3_NavigationDrawerItemDefaults$stableprop_getter() << 24, 255);
            $composer_0.n30();
            tmp_18 = tmp9_group;
          } else {
            $composer_0.m30(-2017156017);
            $composer_0.n30();
            tmp_18 = tmp10_elvis_lhs;
          }
          var tmp12_group = tmp_18;
          $composer_0.n30();
          tmp_17 = tmp12_group;
        } else {
          $composer_0.m30(1892833650);
          sourceInformation($composer_0, '');
          var tmp_27;
          if (!(navigationItemColors == null)) {
            $composer_0.m30(1892883281);
            sourceInformation($composer_0, '989@46619L491');
            var tmp11_$this = NavigationDrawerItemDefaults_getInstance();
            var tmp12_selectedIconColor = navigationItemColors.vpx_1;
            var tmp13_selectedTextColor = navigationItemColors.wpx_1;
            var tmp14_unselectedIconColor = navigationItemColors.ypx_1;
            var tmp15_unselectedTextColor = navigationItemColors.zpx_1;
            var tmp16_selectedContainerColor = navigationItemColors.xpx_1;
            var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp10_group = tmp11_$this.ypw(tmp16_selectedContainerColor, tmp_28, tmp12_selectedIconColor, tmp14_unselectedIconColor, tmp13_selectedTextColor, tmp15_unselectedTextColor, tmp_29, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, androidx_compose_material3_NavigationDrawerItemDefaults$stableprop_getter() << 24, 194);
            $composer_0.n30();
            tmp_27 = tmp10_group;
          } else {
            $composer_0.m30(1893438522);
            sourceInformation($composer_0, '997@47188L12');
            var tmp_30 = NavigationSuiteDefaults_getInstance();
            var tmp11_group = tmp_30.bxo(null, null, null, $composer_0, 3072, 7).hxo_1;
            $composer_0.n30();
            tmp_27 = tmp11_group;
          }
          var tmp13_group = tmp_27;
          $composer_0.n30();
          tmp_17 = tmp13_group;
        }
        var actualColors_1 = tmp_17;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(170493148, true, NavigationSuiteItem$lambda_3(label), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_5.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_31;
        if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver_3);
          $composer_5.j31(value_3);
          tmp_31 = value_3;
        } else {
          tmp_31 = it_3;
        }
        var tmp_32 = tmp_31;
        NavigationDrawerItem(tmp_32, selected, onClick, modifier, icon, badge, null, actualColors_1, interactionSource, $composer_0, 6 | 112 & $dirty >> 3 | 896 & $dirty >> 3 | 7168 & $dirty >> 9 | 57344 & $dirty | 458752 & $dirty >> 9 | 234881024 & $dirty1 << 21, 64);
        $composer_0.n30();
      } else {
        $composer_0.m30(1893944969);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp14_safe_receiver = $composer_0.t30();
    if (tmp14_safe_receiver == null)
      null;
    else {
      tmp14_safe_receiver.p3c(NavigationSuiteItem$lambda_4(isNavigationSuite, navigationSuiteType, selected, onClick, icon, label, modifier, enabled, badge, navigationItemColors, navigationSuiteItemColors, interactionSource, $changed, $changed1));
    }
  }
  function get_isVisible(_this__u8e3s4) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return _this__u8e3s4.equals(NavigationSuiteScaffoldValue_Visible_getInstance());
  }
  function get_isNavigationBar(_this__u8e3s4) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    return _this__u8e3s4 === Companion_getInstance_5().oxm_1 || _this__u8e3s4 === Companion_getInstance_5().pxm_1 || _this__u8e3s4 === Companion_getInstance_5().sxm_1;
  }
  function NavigationSuiteScopeImpl() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.xxo_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(NavigationSuiteScopeImpl).ixn = function (selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource) {
    this.xxo_1.zz(new NavigationSuiteItem(selected, onClick, icon, modifier, enabled, label, alwaysShowLabel, badge, colors, interactionSource));
  };
  protoOf(NavigationSuiteScopeImpl).yxo = function () {
    return this.xxo_1;
  };
  function sam$androidx_compose_ui_layout_MeasurePolicy$0(function_0) {
    this.zxo_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.zxo_1(_this__u8e3s4, measurables, new Constraints(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).q3 = function () {
    return this.zxo_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function NavigationSuiteScaffold$lambda$lambda($layoutType, $navigationSuiteColors, $navigationSuiteItems) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C272@13370L183:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1242867499, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffold.<anonymous>.<anonymous> (NavigationSuiteScaffold.kt:272)');
        }
        var tmp_0 = $layoutType._v;
        NavigationSuite(null, tmp_0 == null ? null : tmp_0.wxm_1, $navigationSuiteColors._v, $navigationSuiteItems, $composer_0, 0, 1);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffold$lambda$lambda_0($state, $layoutType, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C281@13673L1241:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-824130446, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffold.<anonymous>.<anonymous> (NavigationSuiteScaffold.kt:281)');
        }
        var tmp_0 = Companion_instance;
        var tmp_1;
        if ($state._v.i3a().equals(NavigationSuiteScaffoldValue_Hidden_getInstance()) && !$state._v.mxo()) {
          $composer_0.m30(-1636784822);
          $composer_0.n30();
          tmp_1 = get_NoWindowInsets();
        } else {
          $composer_0.m30(-1636686025);
          sourceInformation($composer_0, '');
          var tmp0_subject = $layoutType._v.wxm_1;
          var tmp_2;
          if (tmp0_subject === Companion_getInstance_5().sxm_1) {
            $composer_0.m30(-1715358946);
            sourceInformation($composer_0, '291@14176L12');
            var tmp0_group = only(NavigationBarDefaults_getInstance().bo4($composer_0, androidx_compose_material3_NavigationBarDefaults$stableprop_getter()), Companion_getInstance_4().ae4_1);
            $composer_0.n30();
            tmp_2 = tmp0_group;
          } else if (tmp0_subject === Companion_getInstance_5().txm_1) {
            $composer_0.m30(-1715350915);
            sourceInformation($composer_0, '295@14427L12');
            var tmp1_group = only(NavigationRailDefaults_instance.bo4($composer_0, androidx_compose_material3_NavigationRailDefaults$stableprop_getter()), Companion_getInstance_4().xe3_1);
            $composer_0.n30();
            tmp_2 = tmp1_group;
          } else if (tmp0_subject === Companion_getInstance_5().uxm_1) {
            $composer_0.m30(-1715343185);
            sourceInformation($composer_0, '299@14671L12');
            var tmp2_group = only(DrawerDefaults_getInstance().bo4($composer_0, androidx_compose_material3_DrawerDefaults$stableprop_getter()), Companion_getInstance_4().xe3_1);
            $composer_0.n30();
            tmp_2 = tmp2_group;
          } else {
            $composer_0.m30(-1715340960);
            $composer_0.n30();
            tmp_2 = get_NoWindowInsets();
          }
          var tmp3_group = tmp_2;
          $composer_0.n30();
          tmp_1 = tmp3_group;
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = consumeWindowInsets(tmp_0, tmp_1);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_0().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_2().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_2().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_2().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_2().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_2().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_2().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1051939154, 'C305@14887L9:NavigationSuiteScaffold.kt#94yoxb');
        $content._v($composer_5, 0);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffold$lambda($layoutType, $state, $navigationSuiteColors, $navigationSuiteItems, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C271@13352L215,280@13655L1273,270@13291L1648:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1342772900, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffold.<anonymous> (NavigationSuiteScaffold.kt:270)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1242867499, true, NavigationSuiteScaffold$lambda$lambda($layoutType, $navigationSuiteColors, $navigationSuiteItems), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = $layoutType._v;
        var tmp_3 = tmp_2 == null ? null : tmp_2.wxm_1;
        var tmp_4 = $state._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-824130446, true, NavigationSuiteScaffold$lambda$lambda_0($state, $layoutType, $content), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_5;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_5 = value_0;
        } else {
          tmp_5 = it_0;
        }
        var tmp$ret$7 = tmp_5;
        NavigationSuiteScaffoldLayout(tmp_1, tmp_3, tmp_4, tmp$ret$7, $composer_0, 3078, 0);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffold$lambda_0($navigationSuiteItems, $modifier, $layoutType, $navigationSuiteColors, $containerColor, $contentColor, $state, $content, $$changed, $$default) {
    return function ($composer, $force) {
      var tmp = $modifier._v;
      var tmp_0 = $layoutType._v;
      NavigationSuiteScaffold($navigationSuiteItems, tmp, tmp_0 == null ? null : tmp_0.wxm_1, $navigationSuiteColors._v, $containerColor._v.c6d_1, $contentColor._v.c6d_1, $state._v, $content._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberNavigationSuiteScaffoldState$lambda($initialValue) {
    return function () {
      return new NavigationSuiteScaffoldStateImpl($initialValue._v);
    };
  }
  function NavigationSuiteScaffoldLayout$lambda($navigationSuite, $layoutType, $state, $content, $$changed, $$default) {
    return function ($composer, $force) {
      var tmp = $layoutType._v;
      NavigationSuiteScaffoldLayout($navigationSuite, tmp == null ? null : tmp.wxm_1, $state._v, $content._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda($scope$delegate) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('scope', KProperty0, false);
    return $scope$delegate.u1();
  }
  function NavigationSuite$lambda$lambda($it) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C718@34232L52:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(2036857247, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous>.<anonymous>.<anonymous> (NavigationSuiteScaffold.kt:718)');
        }
        NavigationItemIcon($it.pxo_1, $it.uxo_1, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_0($defaultItemColors, $scope$delegate) {
    return function ($this$NavigationBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*718@34230L56,714@34038L661:NavigationSuiteScaffold.kt#94yoxb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$NavigationBar) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(($dirty & 19) === 18) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(1321804314, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:713)');
        }
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = NavigationSuite$lambda($scope$delegate).yxo();
        var i = 0;
        var tmp_1 = this_0.b3e_1;
        var content = isArray(tmp_1) ? tmp_1 : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it = content[i];
          var tmp2_modifier = it.qxo_1;
          var tmp3_selected = it.nxo_1;
          var tmp4_onClick = it.oxo_1;
          var tmp5_enabled = it.rxo_1;
          var tmp6_label = it.sxo_1;
          var tmp7_alwaysShowLabel = it.txo_1;
          var tmp0_safe_receiver = it.vxo_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fxo_1;
          var tmp8_colors = tmp1_elvis_lhs == null ? $defaultItemColors.fxo_1 : tmp1_elvis_lhs;
          var tmp9_interactionSource = it.wxo_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(2036857247, true, NavigationSuite$lambda$lambda(it), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_2;
          if (invalid || it_0 === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value);
            tmp_2 = value;
          } else {
            tmp_2 = it_0;
          }
          var tmp$ret$2 = tmp_2;
          NavigationBarItem($this$NavigationBar, tmp3_selected, tmp4_onClick, tmp$ret$2, tmp2_modifier, tmp5_enabled, tmp6_label, tmp7_alwaysShowLabel, tmp8_colors, tmp9_interactionSource, $composer_0, 3072 | 14 & $dirty, 0);
          i = i + 1 | 0;
        }
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp_0 = tmp_3;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function NavigationSuite$lambda$lambda_0($it) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C741@35263L52:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(715622380, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous>.<anonymous>.<anonymous> (NavigationSuiteScaffold.kt:741)');
        }
        NavigationItemIcon($it.pxo_1, $it.uxo_1, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_1($defaultItemColors, $scope$delegate) {
    return function ($this$NavigationRail, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*741@35261L56,737@35068L664:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 17) === 16) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(1396067268, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:736)');
        }
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = NavigationSuite$lambda($scope$delegate).yxo();
        var i = 0;
        var tmp_0 = this_0.b3e_1;
        var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it = content[i];
          var tmp2_modifier = it.qxo_1;
          var tmp3_selected = it.nxo_1;
          var tmp4_onClick = it.oxo_1;
          var tmp5_enabled = it.rxo_1;
          var tmp6_label = it.sxo_1;
          var tmp7_alwaysShowLabel = it.txo_1;
          var tmp0_safe_receiver = it.vxo_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gxo_1;
          var tmp8_colors = tmp1_elvis_lhs == null ? $defaultItemColors.gxo_1 : tmp1_elvis_lhs;
          var tmp9_interactionSource = it.wxo_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(715622380, true, NavigationSuite$lambda$lambda_0(it), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_1;
          if (invalid || it_0 === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value);
            tmp_1 = value;
          } else {
            tmp_1 = it_0;
          }
          var tmp$ret$2 = tmp_1;
          NavigationRailItem(tmp3_selected, tmp4_onClick, tmp$ret$2, tmp2_modifier, tmp5_enabled, tmp6_label, tmp7_alwaysShowLabel, tmp8_colors, tmp9_interactionSource, $composer_0, 384, 0);
          i = i + 1 | 0;
        }
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function NavigationSuite$lambda$lambda_1($it) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1790578429, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous>.<anonymous>.<anonymous> (NavigationSuiteScaffold.kt:766)');
        }
        var tmp0_safe_receiver = $it.sxo_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          $composer_0.m30(371850134);
          $composer_0.n30();
          tmp_0 = null;
        } else {
          $composer_0.m30(1536015819);
          sourceInformation($composer_0, '766@36415L8');
          tmp0_safe_receiver($composer_0, 0);
          $composer_0.n30();
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          $composer_0.m30(1536016203);
          sourceInformation($composer_0, '766@36427L8');
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_5 = _TextOverflow___init__impl__obguoe(0);
          Text('', null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
          $composer_0.n30();
        } else {
          $composer_0.m30(1536015521);
          $composer_0.n30();
        }
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_2($defaultItemColors, $scope$delegate) {
    return function ($this$PermanentDrawerSheet, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*766@36403L34,760@36125L581:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 17) === 16) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1884440258, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:759)');
        }
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = NavigationSuite$lambda($scope$delegate).yxo();
        var i = 0;
        var tmp_0 = this_0.b3e_1;
        var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it = content[i];
          var tmp2_modifier = it.qxo_1;
          var tmp3_selected = it.nxo_1;
          var tmp4_onClick = it.oxo_1;
          var tmp5_icon = it.pxo_1;
          var tmp6_badge = it.uxo_1;
          var tmp0_safe_receiver = it.vxo_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hxo_1;
          var tmp7_colors = tmp1_elvis_lhs == null ? $defaultItemColors.hxo_1 : tmp1_elvis_lhs;
          var tmp8_interactionSource = it.wxo_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1790578429, true, NavigationSuite$lambda$lambda_1(it), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_1;
          if (invalid || it_0 === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value);
            tmp_1 = value;
          } else {
            tmp_1 = it_0;
          }
          var tmp_2 = tmp_1;
          NavigationDrawerItem(tmp_2, tmp3_selected, tmp4_onClick, tmp2_modifier, tmp5_icon, tmp6_badge, null, tmp7_colors, tmp8_interactionSource, $composer_0, 6, 64);
          i = i + 1 | 0;
        }
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_3($layoutType, $scope$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*785@37071L712:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-69522256, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:784)');
        }
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = NavigationSuite$lambda($scope$delegate).yxo();
        var i = 0;
        var tmp_0 = this_0.b3e_1;
        var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it = content[i];
          var tmp1_modifier = it.qxo_1;
          var tmp2_selected = it.nxo_1;
          var tmp3_onClick = it.oxo_1;
          var tmp4_icon = it.pxo_1;
          var tmp5_badge = it.uxo_1;
          var tmp6_enabled = it.rxo_1;
          var tmp7_label = it.sxo_1;
          var tmp0_elvis_lhs = it.vxo_1;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            $composer_0.m30(-1318161508);
            sourceInformation($composer_0, '796@37629L12');
            var tmp_2 = NavigationSuiteDefaults_getInstance();
            var tmp0_group = tmp_2.bxo(null, null, null, $composer_0, 3072, 7);
            $composer_0.n30();
            tmp_1 = tmp0_group;
          } else {
            $composer_0.m30(-1318162655);
            $composer_0.n30();
            tmp_1 = tmp0_elvis_lhs;
          }
          var tmp8_navigationSuiteItemColors = tmp_1;
          var tmp9_interactionSource = it.wxo_1;
          NavigationSuiteItem_0(true, $layoutType._v.wxm_1, tmp2_selected, tmp3_onClick, tmp4_icon, tmp7_label, tmp1_modifier, tmp6_enabled, tmp5_badge, null, tmp8_navigationSuiteItemColors, tmp9_interactionSource, $composer_0, 805306374, 0);
          i = i + 1 | 0;
        }
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_4($modifier, $layoutType, $colors, $content, $$changed, $$default) {
    return function ($composer, $force) {
      var tmp = $modifier._v;
      var tmp_0 = $layoutType._v;
      NavigationSuite(tmp, tmp_0 == null ? null : tmp_0.wxm_1, $colors._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate) {
    _init_properties_NavigationSuiteScaffold_kt__g9n19k();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('animationProgress', KProperty0, false);
    return $animationProgress$delegate.u1();
  }
  function NavigationSuiteScaffoldLayout$lambda$lambda($isNavigationBar, $contentPlaceable, $navigationPlaceable, $layoutHeight, $primaryActionContentHorizontalAlignment, $layoutWidth, $primaryActionContentPlaceable, $animationProgress$delegate) {
    return function ($this$layout) {
      var tmp;
      if ($isNavigationBar) {
        $this$layout.a98($contentPlaceable, 0, 0);
        $this$layout.a98($navigationPlaceable, 0, $layoutHeight - numberToInt($navigationPlaceable.j8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0);
        var tmp_0;
        if (equals($primaryActionContentHorizontalAlignment._v, Companion_getInstance_0().w8t_1)) {
          tmp_0 = $this$layout.w5e(get_PrimaryActionContentPadding());
        } else if (equals($primaryActionContentHorizontalAlignment._v, Companion_getInstance_0().x8t_1)) {
          tmp_0 = ($layoutWidth - $primaryActionContentPlaceable.i8y_1 | 0) / 2 | 0;
        } else {
          tmp_0 = ($layoutWidth - $primaryActionContentPlaceable.i8y_1 | 0) - $this$layout.w5e(get_PrimaryActionContentPadding()) | 0;
        }
        var positionX = tmp_0;
        $this$layout.a98($primaryActionContentPlaceable, positionX, (($layoutHeight - $primaryActionContentPlaceable.j8y_1 | 0) - $this$layout.w5e(get_PrimaryActionContentPadding()) | 0) - numberToInt($navigationPlaceable.j8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0);
        tmp = Unit_instance;
      } else {
        $this$layout.a98($navigationPlaceable, numberToInt(0 - $navigationPlaceable.i8y_1 * (1.0 - NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate))), 0);
        $this$layout.a98($contentPlaceable, numberToInt($navigationPlaceable.i8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)), 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffoldLayout$lambda_1($navigationSuiteType, $animationProgress$delegate, $primaryActionContentHorizontalAlignment) {
    return function ($this$Layout, measurables, constraints) {
      var looseConstraints = Constraints__copy$default_impl_f452rp(constraints.m5e_1, 0, VOID, 0);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastFirst' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = measurables.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = measurables.l1(index);
            if (equals(get_layoutId(item), 'navigationSuite')) {
              tmp$ret$0 = item;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        throwNoSuchElementException('Collection contains no element matching the predicate.');
      }
      var navigationPlaceable = tmp$ret$0.h8y(looseConstraints);
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.util.fastFirst' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = measurables.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = measurables.l1(index_0);
            if (equals(get_layoutId(item_0), 'primaryActionContent')) {
              tmp$ret$4 = item_0;
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        throwNoSuchElementException('Collection contains no element matching the predicate.');
      }
      var primaryActionContentPlaceable = tmp$ret$4.h8y(looseConstraints);
      var isNavigationBar = get_isNavigationBar($navigationSuiteType);
      var layoutHeight = _Constraints___get_maxHeight__impl__dt3e8z(constraints.m5e_1);
      var layoutWidth = _Constraints___get_maxWidth__impl__uuyqc(constraints.m5e_1);
      var tmp$ret$8;
      $l$block_1: {
        // Inline function 'androidx.compose.ui.util.fastFirst' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_1 = 0;
        var last_1 = measurables.n1() - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var index_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var item_1 = measurables.l1(index_1);
            if (equals(get_layoutId(item_1), 'content')) {
              tmp$ret$8 = item_1;
              break $l$block_1;
            }
          }
           while (inductionVariable_1 <= last_1);
        throwNoSuchElementException('Collection contains no element matching the predicate.');
      }
      var tmp = tmp$ret$8;
      var tmp_0;
      if (isNavigationBar) {
        tmp_0 = Constraints__copy$default_impl_f452rp(constraints.m5e_1, VOID, VOID, layoutHeight - numberToInt(navigationPlaceable.j8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0, layoutHeight - numberToInt(navigationPlaceable.j8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0);
      } else {
        tmp_0 = Constraints__copy$default_impl_f452rp(constraints.m5e_1, layoutWidth - numberToInt(navigationPlaceable.i8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0, layoutWidth - numberToInt(navigationPlaceable.i8y_1 * NavigationSuiteScaffoldLayout$lambda_0($animationProgress$delegate)) | 0);
      }
      var contentPlaceable = tmp.h8y(tmp_0);
      return $this$Layout.n8y(layoutWidth, layoutHeight, VOID, NavigationSuiteScaffoldLayout$lambda$lambda(isNavigationBar, contentPlaceable, navigationPlaceable, layoutHeight, $primaryActionContentHorizontalAlignment, layoutWidth, primaryActionContentPlaceable, $animationProgress$delegate));
    };
  }
  function NavigationSuiteScaffoldLayout$lambda_2($navigationSuite, $navigationSuiteType, $state, $primaryActionContent, $primaryActionContentHorizontalAlignment, $content, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationSuiteScaffoldLayout_0($navigationSuite, $navigationSuiteType, $state._v, $primaryActionContent._v, $primaryActionContentHorizontalAlignment._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberStateOfItems$lambda($latestContent) {
    return function () {
      var tmp0 = new NavigationSuiteScopeImpl();
      // Inline function 'kotlin.apply' call
      $latestContent.u1()(tmp0);
      return tmp0;
    };
  }
  function NavigationItemIcon$lambda($badge) {
    return function ($this$BadgedBox, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1558@71897L8:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 17) === 16) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-427323906, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationItemIcon.<anonymous> (NavigationSuiteScaffold.kt:1558)');
        }
        $badge._v($composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_2(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function NavigationItemIcon$lambda_0($icon) {
    return function ($this$BadgedBox, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1558@71911L6:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 17) === 16) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1775457476, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationItemIcon.<anonymous> (NavigationSuiteScaffold.kt:1558)');
        }
        $icon($composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationItemIcon$lambda_1($icon, $badge, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationItemIcon($icon, $badge._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_5($primaryActionContent) {
    return function ($this$NavigationRail, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C634@30556L22:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 17) === 16) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(872457991, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:634)');
        }
        $primaryActionContent._v($composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_6($verticalArrangement, $movableContent) {
    return function ($this$NavigationRail, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C644@30988L16:NavigationSuiteScaffold.kt#94yoxb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$NavigationRail) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(($dirty & 19) === 18) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(172391621, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:638)');
        }
        if (equals($verticalArrangement._v, Arrangement_getInstance().udp_1) || equals($verticalArrangement._v, Arrangement_getInstance().tdp_1)) {
          $composer_0.m30(-1061932102);
          sourceInformation($composer_0, '642@30926L27');
          Spacer($this$NavigationRail.yds(Companion_instance, 1.0), $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1061867715);
          $composer_0.n30();
        }
        $movableContent($composer_0, 0);
        if (equals($verticalArrangement._v, Arrangement_getInstance().udp_1)) {
          $composer_0.m30(-1061769414);
          sourceInformation($composer_0, '646@31090L27');
          Spacer($this$NavigationRail.yds(Companion_instance, 1.0), $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1061705027);
          $composer_0.n30();
        }
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_7($primaryActionContent, $verticalArrangement, $movableContent) {
    return function ($this$PermanentDrawerSheet, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C658@31598L22,665@31875L16:NavigationSuiteScaffold.kt#94yoxb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$PermanentDrawerSheet) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!(($dirty & 19) === 18) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-1983694325, $dirty, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuite.<anonymous> (NavigationSuiteScaffold.kt:658)');
        }
        $primaryActionContent._v($composer_0, 0);
        if (equals($verticalArrangement._v, Arrangement_getInstance().udp_1) || equals($verticalArrangement._v, Arrangement_getInstance().tdp_1)) {
          $composer_0.m30(-1782399020);
          sourceInformation($composer_0, '663@31813L27');
          Spacer($this$PermanentDrawerSheet.yds(Companion_instance, 1.0), $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1782334633);
          $composer_0.n30();
        }
        $movableContent($composer_0, 0);
        if (equals($verticalArrangement._v, Arrangement_getInstance().udp_1)) {
          $composer_0.m30(-1782236332);
          sourceInformation($composer_0, '667@31977L27');
          Spacer($this$PermanentDrawerSheet.yds(Companion_instance, 1.0), $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1782171945);
          $composer_0.n30();
        }
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuite$lambda_8($navigationSuiteType, $modifier, $colors, $verticalArrangement, $primaryActionContent, $content, $$changed, $$default) {
    return function ($composer, $force) {
      NavigationSuite_0($navigationSuiteType, $modifier._v, $colors._v, $verticalArrangement._v, $primaryActionContent._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda($icon, $badge) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C888@41413L46:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-715321418, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem.<anonymous> (NavigationSuiteScaffold.kt:888)');
        }
        NavigationItemIcon($icon, $badge, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda_0($icon, $badge) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C904@42152L46:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(929903317, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem.<anonymous> (NavigationSuiteScaffold.kt:904)');
        }
        NavigationItemIcon($icon, $badge, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda_1($icon, $badge) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C939@44067L46:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(-217991490, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem.<anonymous> (NavigationSuiteScaffold.kt:939)');
        }
        NavigationItemIcon($icon, $badge, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda_2($icon, $badge) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C972@45820L46:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(2005188384, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem.<anonymous> (NavigationSuiteScaffold.kt:972)');
        }
        NavigationItemIcon($icon, $badge, $composer_0, 0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda_3($label) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:NavigationSuiteScaffold.kt#94yoxb');
      var tmp;
      if (!(($changed & 3) === 2) || !$composer_0.i30()) {
        if (isTraceInProgress()) {
          traceEventStart(170493148, $changed, -1, 'androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem.<anonymous> (NavigationSuiteScaffold.kt:1007)');
        }
        var tmp0_safe_receiver = $label;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          $composer_0.m30(-1784929923);
          $composer_0.n30();
          tmp_0 = null;
        } else {
          $composer_0.m30(635158276);
          sourceInformation($composer_0, '1007@47505L8');
          tmp0_safe_receiver($composer_0, 0);
          $composer_0.n30();
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          $composer_0.m30(635158660);
          sourceInformation($composer_0, '1007@47517L8');
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_5 = _TextOverflow___init__impl__obguoe(0);
          Text('', null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
          $composer_0.n30();
        } else {
          $composer_0.m30(635158071);
          $composer_0.n30();
        }
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavigationSuiteItem$lambda_4($isNavigationSuite, $navigationSuiteType, $selected, $onClick, $icon, $label, $modifier, $enabled, $badge, $navigationItemColors, $navigationSuiteItemColors, $interactionSource, $$changed, $$changed1) {
    return function ($composer, $force) {
      NavigationSuiteItem_0($isNavigationSuite, $navigationSuiteType, $selected, $onClick, $icon, $label, $modifier, $enabled, $badge, $navigationItemColors, $navigationSuiteItemColors, $interactionSource, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1));
      return Unit_instance;
    };
  }
  function NavigationSuiteScaffoldValue_Visible_getInstance() {
    NavigationSuiteScaffoldValue_initEntries();
    return NavigationSuiteScaffoldValue_Visible_instance;
  }
  function NavigationSuiteScaffoldValue_Hidden_getInstance() {
    NavigationSuiteScaffoldValue_initEntries();
    return NavigationSuiteScaffoldValue_Hidden_instance;
  }
  var properties_initialized_NavigationSuiteScaffold_kt_dm3qx6;
  function _init_properties_NavigationSuiteScaffold_kt__g9n19k() {
    if (!properties_initialized_NavigationSuiteScaffold_kt_dm3qx6) {
      properties_initialized_NavigationSuiteScaffold_kt_dm3qx6 = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      TallNavigationBarHeight = _Dp___init__impl__ms3zkb(80);
      // Inline function 'androidx.compose.ui.unit.dp' call
      PrimaryActionContentPadding = _Dp___init__impl__ms3zkb(16);
      NoWindowInsets = WindowInsets(0, 0, 0, 0);
      AnimationSpec = spring(0.9, 700.0);
      androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteScaffoldDefaults$stable = 0;
      androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteDefaults$stable = 0;
      androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteColors$stable = 0;
      androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteItemColors$stable = 0;
      androidx_compose_material3_adaptive_navigationsuite_NavigationSuiteScaffoldStateImpl$stable = 0;
    }
  }
  var androidx_compose_material3_adaptive_navigationsuite_DpWidthSizeClasses$stable;
  var androidx_compose_material3_adaptive_navigationsuite_DpHeightSizeClasses$stable;
  function get_minWidth(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = _this__u8e3s4.qxl_1;
    return _Dp___init__impl__ms3zkb(this_0);
  }
  function DpWidthSizeClasses() {
    DpWidthSizeClasses_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.wxn_1 = _Dp___init__impl__ms3zkb(0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.xxn_1 = _Dp___init__impl__ms3zkb(600);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.yxn_1 = _Dp___init__impl__ms3zkb(840);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_2.zxn_1 = _Dp___init__impl__ms3zkb(1200);
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_3.axo_1 = _Dp___init__impl__ms3zkb(1600);
  }
  var DpWidthSizeClasses_instance;
  function DpWidthSizeClasses_getInstance() {
    if (DpWidthSizeClasses_instance == null)
      new DpWidthSizeClasses();
    return DpWidthSizeClasses_instance;
  }
  function get_WidthSizeClasses(_this__u8e3s4) {
    return DpWidthSizeClasses_getInstance();
  }
  function get_minHeight(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.unit.dp' call
    var this_0 = _this__u8e3s4.rxl_1;
    return _Dp___init__impl__ms3zkb(this_0);
  }
  function DpHeightSizeClasses() {
    DpHeightSizeClasses_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.txn_1 = _Dp___init__impl__ms3zkb(0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.uxn_1 = _Dp___init__impl__ms3zkb(480);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.vxn_1 = _Dp___init__impl__ms3zkb(900);
  }
  var DpHeightSizeClasses_instance;
  function DpHeightSizeClasses_getInstance() {
    if (DpHeightSizeClasses_instance == null)
      new DpHeightSizeClasses();
    return DpHeightSizeClasses_instance;
  }
  function get_HeightSizeClasses(_this__u8e3s4) {
    return DpHeightSizeClasses_getInstance();
  }
  //region block: post-declaration
  protoOf(NavigationSuiteScopeImpl).jxn = item$default;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).nak = minIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).oak = minIntrinsicHeight;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).pak = maxIntrinsicWidth;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).qak = maxIntrinsicHeight;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion_0();
  androidx_compose_material3_adaptive_navigationsuite_DpWidthSizeClasses$stable = 0;
  androidx_compose_material3_adaptive_navigationsuite_DpHeightSizeClasses$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = NavigationSuiteScaffold;
  _.$_$.b = Companion_getInstance_5;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite.js.map
